import axiosInstance from "../../_utils/axiosConfig";
export const relevate = async ()=>{
    try{
        const response = await axiosInstance.get(`${process.env.REACT_APP_BASE_URL}/api/releves`);
        return response.data;
    }catch(error){
        console.log("Erreur lors de la recuperation ",error);
        throw error;
    }
}